/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React, { memo } from 'react';
import { SectionListBodyProps } from './types';
import { generateID } from '../../base/helper';

const Body: React.FC<SectionListBodyProps> = ({
  children,
  borderBottom = false,
  id = generateID('clientos-ui-toolkit-section-list-container-body')
}) => {
  return (
    <>
      <div
        className="clientos-ui-toolkit-section-list-container__content__body"
        id={id}
      >
        {children}
      </div>
      {borderBottom && (
        <div className="clientos-ui-toolkit-section-list-container__item__separator" />
      )}
    </>
  );
};
export default memo(Body);
